export default class {
  public value: string;
  public displayName: string;

  public constructor(model: { value: string; displayName?: string }) {
    this.value = model.value;
    this.displayName = model.displayName || model.value;
  }
}
